export default __webpack_public_path__ + "static/media/bomb.d318b190.png";